import { Chip, Spinner } from "@heroui/react";
import { Coins } from "lucide-react";
import { useCreditBalance } from "@src/presentation/hooks/credits";

interface CreditBadgeProps {
    showLabel?: boolean;
    size?: "sm" | "md" | "lg";
}

export function CreditBadge({ showLabel = true, size = "sm" }: CreditBadgeProps) {
    const { data: creditBalance, isLoading, error } = useCreditBalance();

    if (isLoading) {
        return (
            <div className="flex items-center gap-2 px-2">
                <Spinner size="sm" color="default" />
            </div>
        );
    }

    if (error || !creditBalance) {
        return null; // Silently fail if credits can't be loaded
    }

    const { remainingCredits, usagePercentage } = creditBalance.balance;

    // Determine color based on usage
    const getColor = () => {
        if (usagePercentage >= 90) return "danger";
        if (usagePercentage >= 70) return "warning";
        return "success";
    };

    return (
        <Chip
            startContent={<Coins className="h-4 w-4" />}
            variant="flat"
            color={getColor()}
            size={size}
            className="cursor-pointer"
        >
            <span className="font-semibold">
                {showLabel && "Credits: "}
                {remainingCredits.toLocaleString()}
            </span>
        </Chip>
    );
}
